<template>
  <v-alert
    id="svp-message-view"
    v-bind="$attrs"
    :elevation="elevation"
    tile
    class="pt-5"
  >
    <div id="message-view-column">
      <h1
        v-if="title"
        id="view-title"
        class="mb-6"
        v-html="title"
      />
      <slot name="message">
        <h2
          id="view-message"
          v-html="message"
        />
      </slot>
      <slot name="reference-id" />
      <p
        v-if="footer"
        id="view-footer"
      >
        {{ footer }}
      </p>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'MessageView',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    message: {
      type: String,
      required: true
    },
    footer: {
      type: String,
      required: false,
      default: ''
    },
    elevation: {
      type: [Number, String],
      required: false,
      default: 6
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

#svp-message-view {
  max-width: 800px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 168px auto 40px auto;
  background: #fff !important;

  #message-view-column {
    color: #000;
  }

  h1 {
    font: 700 20px Gotham;
  }

  h2,
  ::v-deep h2 {
    font-family: Gotham-Book;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 28px;
    font-weight: normal;
  }

  p {
    font: 400 12px Gotham;
  }
}

@media screen and (max-width: $breakpoint-lg - 1) {
  #svp-message-view {
    margin-top: 148px;
  }
}
</style>
